import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "swiper/css";
import { Quote } from "lucide-react";
import hero2 from "../assets/hero/1.jpg";
import hero3 from "../assets/hero/2.jpg";
import hero4 from "../assets/hero/3.jpg";
import hero5 from "../assets/hero/5.jpg";
import hero6 from "../assets/hero/6.jpg";
import LoadingScreen from "./LoadingScreen";
import Header from "./Header";

const images = [hero2, hero3, hero4, hero5, hero6];

const Hero = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadImages = async () => {
      try {
        await Promise.all(
          images.map(
            (image) =>
              new Promise((resolve, reject) => {
                const img = new Image();
                img.src = image;
                img.onload = resolve;
                img.onerror = reject;
              })
          )
        );
      } catch (error) {
        console.error("Error loading images:", error);
      } finally {
        setIsLoading(false);
      }
    };
    loadImages();
  }, []);

  return (
    <div className="w-full relative">
      <Header />
      <LoadingScreen isLoading={isLoading} />

      {!isLoading && (
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          loop
          className="w-full h-[90vh]"
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <div className="relative w-full h-full">
                <LazyLoadImage
                  src={image}
                  alt={`Slide ${index + 1}`}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="absolute inset-0 flex flex-col justify-center text-white gap-4 md:gap-6
                                px-4 sm:px-6 md:pl-20
                                items-center md:items-start
                                text-center md:text-left">

                  <h1 className="text-5xl sm:text-6xl md:text-6xl lg:text-7xl xl:text-8xl font-extrabold leading-snug md:leading-tight">
                    TECH X{" "}
                    <span className="text-yellow-400 inline-flex items-center gap-2">
                      AFRICA 25 <Quote size={30} />
                    </span>
                  </h1>

                  <p className="text-2xl sm:text-3xl md:text-2xl lg:text-3xl font-semibold ml-4 mt-2">
                    The Future of Technology{" "}
                    <span className="text-[#F63A0A]">Africa Conference</span>
                  </p>

                  <p className="text-lg sm:text-xl md:text-lg lg:text-xl ml-4 font-medium ">
                    Sat May 9th, 2025 | University of Ibadan
                  </p>

                  <div className="mt-6 flex flex-col sm:flex-row items-center md:ml-4 gap-4 md:gap-6 w-full sm:w-auto">
                    <a
                      href="https://www.youtube.com/playlist?list=PLV0eoA2f4X5rpLQRE-TmFPyYF5L0IkYW5"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full sm:w-auto bg-[#F63A0A] hover:bg-red-600 text-white font-semibold rounded-xl px-10 py-5 sm:px-8 sm:py-4 md:px-12 md:py-4 text-base sm:text-lg md:text-base transition-transform transform hover:scale-105 shadow-lg"
                    >
                      Watch Here
                    </a>

                    <a
                      href="/media-about-us"
                      className="w-full sm:w-auto bg-[#F63A0A] hover:bg-red-600 text-white font-semibold rounded-xl px-10 py-5 sm:px-8 sm:py-4 md:px-12 md:py-4 text-base sm:text-lg md:text-base transition-transform transform hover:scale-105 shadow-lg"
                    >
                      Media
                    </a>

                    {/* <button
                      className="w-full sm:w-auto bg-[#F63A0A] hover:bg-red-600 text-white font-semibold rounded-xl px-10 py-5 sm:px-8 sm:py-4 md:px-12 md:py-4 text-base sm:text-lg md:text-base transition-transform transform hover:scale-105 shadow-lg"
                      onClick={() => {
                        window.scrollTo({
                          top: window.innerHeight * 5.8,
                          behavior: "smooth",
                        });
                      }}
                    >
                      Get Ticket
                    </button> */}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
};

export default Hero;
